<script>
import BrandLayout from '../components/Layout'
import DialogLogin from '@components/Dialog/Login'
import DialogRegisterGroup from '@components/Dialog/RegisterGroup'
import ArticleContentEvent from '@components/Article/ArticleContentEvent'
import ArticleSide from '@components/Article/ArticleSide'
import ListIntroduction from '@components/List/Introduction'
import ItemMultiple from './ItemMultiple'
import { authComputed } from '@store/helpers'
import { COURSE_LIST } from '@src/config/fake-data'
import { FAKE_EVENT_ITEM } from '@src/config/fake-evnet'
import { eventIsDealerOnly } from '@utils/zerone-event'
import pageGAMixin from '../mixins/pageGA'
import { eventSessionBigButtonStatusItem } from '@utils/zerone-event-status'
import router from '@router/index'

export default {
  page() {
    return {
      title: `${this.defaultValue.title} | 課程活動`,
    }
  },
  components: {
    DialogLogin,
    DialogRegisterGroup,
    BrandLayout,
    ArticleContentEvent,
    ArticleSide,
    ItemMultiple,
    ListIntroduction,
  },
  mixins: [pageGAMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => {
        return FAKE_EVENT_ITEM
      },
    },
  },
  data() {
    return {
      // FIXME: 要改成 api 提供的 ga id
      type: 'event',
      courseList: COURSE_LIST,
      isDialogLoginVisible: false,
      callbackLogin: () => {},
      isDialogRegisterGroupVisilbe: false,
      showApplyStatus: false,
    }
  },
  computed: {
    ...authComputed,
    isDealerOnly() {
      return eventIsDealerOnly({ ...this.defaultValue })
    },
    sessionBigButtonStatusItem() {
      return eventSessionBigButtonStatusItem({
        ...this.defaultValue,
      })
    },
    defaultValueImgClass() {
      if (!this.defaultValue.bannerImage) {
        return 'isStyleWhite isDefaultBgEventItem'
      } else {
        return 'isDefaultBannerImage'
      }
    },
  },

  methods: {
    onApply({ sessionUuids }) {
      const loggedInFn = () => {
        this.isDialogLoginVisible = false

        this.$nextTick(() => {
          if (this.isDealerOnly && this.currentMember.groupId !== 6) {
            this.isDialogRegisterGroupVisilbe = true
          } else {
            this.tryToRemoverCart().then(() => {
              this.tryToStoreCart({ sessionUuids }).then(() => {
                const goToApplyCheckout = () => {
                  this.$router.push({
                    name: 'event-apply',
                  })
                }
                goToApplyCheckout()
              })
            })
          }
        })
      }

      if (this.loggedIn) {
        loggedInFn()
      } else {
        this.callbackLogin = () => {
          loggedInFn()
        }

        this.isDialogLoginVisible = true
      }
    },
    async tryToRemoverCart() {
      await this.$store.dispatch('cart/removerCart').then((res) => {
        if (res.code === 403) {
          this.$store.dispatch('auth/logOut').then(() => {
            router.push({
              name: 'login',
              query: {
                redirectFrom: location.pathname,
              },
            })
          })
        } else {
          return true
        }
      })
    },
    async tryToStoreCart({ sessionUuids }) {
      await this.$store
        .dispatch('cart/storeCart', {
          eventAlias: this.defaultValue.alias,
          eventSeriesNum: this.defaultValue.seriesNum,
          sessionUuids,
        })
        .then(() => {
          return true
        })
    },
    onMobileMenuOpen(val) {
      this.showApplyStatus = val
    },
  },
}
</script>
<template>
  <BrandLayout :page-type="type" @mobileOpen="onMobileMenuOpen">
    <BaseBanner
      :title="defaultValue.title"
      type="article"
      :image="defaultValue.bannerImage ? defaultValue.bannerImage : require('@assets/images/course/index_banner.png')"
      :custom-class="defaultValueImgClass"
    >
      <el-tag v-if="defaultValue.type === 'online'" class="isStylePrimary isAngle"> LIVE </el-tag>
    </BaseBanner>
    <!-- 單天 -->
    <template v-if="defaultValue.dateType === 'single'">
      <!-- 單場（統一） -->
      <template v-if="defaultValue.registrationType === 'impartial'">
        <div class="container">
          <div class="row">
            <div class="col-lg-7 order-lg-first order-last">
              <ArticleContentEvent :event-item="defaultValue" @apply="onApply" />
            </div>
            <div class="col-lg-5">
              <BaseSticky :offset="-190" :banner-height="415" :menu-height="113" :space-top="123" :space-bottom="40">
                <ArticleSide :type="type" :event-item="defaultValue" @apply="onApply" />
              </BaseSticky>
            </div>
          </div>
        </div>
      </template>
      <!-- 多場（分場次） -->
      <template v-if="defaultValue.registrationType === 'partial'">
        <ListIntroduction :event-item="defaultValue" />
        <ItemMultiple :event-item="defaultValue" @apply="onApply" />
      </template>
    </template>
    <!-- 多天, 系列 -->
    <template v-if="defaultValue.dateType === 'multiple' || defaultValue.dateType === 'series'">
      <ListIntroduction :event-item="defaultValue" />
      <ItemMultiple :event-item="defaultValue" @apply="onApply" />
    </template>
    <BaseButton
      v-if="sessionBigButtonStatusItem.display && defaultValue.registrationType === 'impartial'"
      :class="[$style.mobileEventFixedBtn, sessionBigButtonStatusItem.class, { [$style['active']]: showApplyStatus }]"
      class="isRadius d-md-none"
      :disabled="sessionBigButtonStatusItem.disabled"
      style="opacity: 1"
      @click="onApply"
    >
      {{ sessionBigButtonStatusItem.disabled ? '無法報名' : sessionBigButtonStatusItem.title }}
    </BaseButton>
    <BasePre>{{ defaultValue }}</BasePre>
    <DialogLogin :visible.sync="isDialogLoginVisible" @login="callbackLogin" />
    <DialogRegisterGroup :visible.sync="isDialogRegisterGroupVisilbe" :text="defaultValue.categoryTitle || '課程'" />
  </BrandLayout>
</template>
<style lang="scss" module>
.mobileEventFixedBtn {
  position: fixed;
  bottom: 176px;
  right: 10px;
  width: 60px;
  height: 60px;
  padding: 10px !important;
  text-align: center;
  white-space: unset;
  font-size: 0.875rem !important;
  letter-spacing: 0.1em;
  line-height: 1.45;
  z-index: 3;
  &.active {
    bottom: 301px;
  }
}
</style>
